"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _Basic = _interopRequireDefault(require("./templates/Basic"));
var _MediaModal = _interopRequireDefault(require("./templates/MediaModal"));
var _Video = _interopRequireDefault(require("./templates/Video"));
var _Signup = _interopRequireDefault(require("./templates/Signup"));
var _Gallery = _interopRequireDefault(require("./templates/Gallery"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var templates = {
  Basic: _Basic["default"],
  Video: _Video["default"],
  MediaModal: _MediaModal["default"],
  Signup: _Signup["default"],
  Gallery: _Gallery["default"]
};
var modalCustomStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(92, 92, 92, 0.5)',
    zIndex: 'var(--zindex-overlay)'
  },
  content: {
    position: 'relative',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderWidth: 0,
    backgroundColor: 'var(--color-white)',
    padding: 0,
    borderRadius: 'var(--radius-md)',
    width: 'var(--max-width-xxs)',
    maxHeight: '90vh',
    maxWidth: '90%',
    minWidth: '50%',
    overflow: 'scroll',
    boxShadow: 'var(--shadow-lg)',
    zIndex: 'var(--zindex-overlay)'
  }
};
var modalGalleryStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#000000',
    zIndex: 'var(--zindex-overlay)'
  },
  content: {
    position: 'relative',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderWidth: 0,
    padding: 0,
    backgroundColor: '#000000',
    paddingBottom: 10,
    borderRadius: 'var(--radius-md)',
    height: '100%',
    width: '100%',
    paddingTop: 44,
    minWidth: '50%',
    overflow: 'scroll',
    boxShadow: 'var(--shadow-lg)',
    zIndex: 'var(--zindex-overlay)'
  }
};
var Modal = function Modal(props) {
  var toggle = props.toggle,
    on = props.on,
    template = props.template,
    style = props.style;
  // alreadyHidden stuff is here because if you open modal in mobile menu which already applied
  // overflow hidden on body it will break it on close
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    alreadyHidden = _useState2[0],
    setAlreadyHidden = _useState2[1];
  (0, _react.useEffect)(function () {
    if (on) {
      if (document.body.style.overflow === 'hidden') {
        setAlreadyHidden(true);
      }
      document.body.style.overflow = 'hidden';
    }
    return function () {
      if (!alreadyHidden && on) {
        document.body.style.overflow = 'unset';
      }
    };
  });
  var TemplateSelected = templates[template];
  var useGalleryStyles = ['Video', 'Gallery'].includes(template);
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    closeTimeoutMS: 200,
    contentLabel: "Modal",
    style: useGalleryStyles ? _objectSpread(_objectSpread({}, modalGalleryStyle), {}, {
      content: _objectSpread(_objectSpread({}, modalGalleryStyle.content), style)
    }) : _objectSpread(_objectSpread({}, modalCustomStyle), {}, {
      content: _objectSpread(_objectSpread({}, modalCustomStyle.content), style)
    }),
    className: useGalleryStyles ? 'd8-gallery-modal-wrap' : '',
    isOpen: on,
    onRequestClose: toggle,
    ariaHideApp: false
  }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, props));
};
Modal.propTypes = {
  template: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  toggle: _propTypes["default"].func,
  on: _propTypes["default"].bool.isRequired,
  noCloseIcon: _propTypes["default"].bool,
  cta: _propTypes["default"].object,
  style: _propTypes["default"].object
};
Modal.defaultProps = {
  template: 'Basic'
};
var _default = exports["default"] = Modal;